import { Options } from 'ky';
import qs from 'qs';
import config from 'Datev/config';
import { useAuthenticatedApiClient } from 'utils/apiClient/base';
import { DsFinvkExport } from 'utils/apiClient/services/reports/types';
import {
  Cursor,
  DatevAuthPayload,
  DateVLogsPayload,
  DatevSettings,
} from './types';

const datevClientOpts: Options = {
  prefixUrl: `${config.datevServiceApi}`,
};

const customJsonHeader = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

/* eslint-disable import/prefer-default-export */
export const useDatevApi = () => {
  const authenticatedApiClient = useAuthenticatedApiClient();
  const datevApiClient = authenticatedApiClient.extend(datevClientOpts);
  return {
    getRedirectParams: () =>
      datevApiClient
        .get('credentials/redirect_parameters/', {
          headers: customJsonHeader,
        })
        .json<DatevSettings>(),
    getAccountAuth: () =>
      datevApiClient
        .get('credentials/mine/', {
          headers: customJsonHeader,
        })
        .json<DatevAuthPayload>(),
    postRedirectResult: (redirectPayload: Cursor) =>
      datevApiClient.post('credentials/redirect_response/', {
        headers: customJsonHeader,
        body: JSON.stringify(redirectPayload),
      }),
    fetchLogs: (cursor: Cursor) => {
      const params = qs.stringify({ cursor });
      return datevApiClient
        .get(`events/`, {
          searchParams: params,
          headers: customJsonHeader,
        })
        .json<DateVLogsPayload>();
    },

    fetchDsFinvkExports: () =>
      datevApiClient
        .get(`cpcs/dsfinvk_export/`, {
          headers: customJsonHeader,
        })
        .json<Array<DsFinvkExport>>(),
    postDsFinvkExport: (payload: any) => {
      const formData = new FormData();
      formData.append('status', 'INITIAL');
      formData.append('from_date', payload.from_date);
      formData.append('to_date', payload.to_date);
      formData.append('inv_account_id', payload.account_id);
      return datevApiClient
        .post(`cpcs/dsfinvk_export/`, {
          body: formData,
        })
        .json();
    },
  };
};
